import { Component, OnInit, Inject } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { invoiceData } from "./invoiceData.model";
import { SortEvent, SortDirection } from "@aposin/ng-aquila/table";
import { NxMessageToastService } from "@aposin/ng-aquila/message";
import { throwError } from "rxjs";
import { MESSAGE_CONSTS } from "../ValidationMessages";
import * as moment from 'moment';

@Component({
  selector: 'app-non-covered-services',
  templateUrl: './non-covered-services.component.html',
  styleUrls: ['./non-covered-services.component.css']
})
export class NonCoveredServicesComponent implements OnInit {
  invoiceModalOpen: boolean = false;
  isSuccess: boolean = false;
  confirmModalOpen: boolean = false;
  invoiceForm: FormGroup;
  clientId: number;
  EDIT_FLAG: boolean;
  invoiceData: invoiceData = new invoiceData();
  invoiceId;
  invoiceName;
  invoiceList = [];
  _apiUrl: string;
  invoiceRole: string;
  clientList: any;
  workshopList: [];
  workshopId: number;
  workshopName: string;
  /**Pagination Start */
  count: number;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  Id: number;
  errorMessage: string;
  policyStartDate: moment.Moment;
  policyEndDate: moment.Moment;
  invoiceDate: moment.Moment;
  serviceDate: moment.Moment;
  closed: boolean;
  fileName: string;
  ReportData: any;
  exportdata: any = [];
  isDealer:boolean=false;
  selectedItem:any;

  prevPage() {
    this.pageNumber--;
    this.getinvoiceList();
  }

  nextPage() {
    this.pageNumber++;
    this.getinvoiceList();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getinvoiceList();
  }
  /**Pagination end */
  /** sorting starts here */

  sortTable(sort: SortEvent) {
    //Sorts the table data by a certain category.
    this.invoiceList = this.invoiceList.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection
  ) {
    return (a < b ? -1 : 1) * (direction === "asc" ? 1 : -1);
  }
  /** sorting ends here */

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,

    private messageToastService: NxMessageToastService
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.invoiceName = localStorage.getItem("invoice_NAME");
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.invoiceRole = atob(localStorage.getItem("invoiceRole"));
  }

  ngOnInit() {
    this.getworkshopList();
    this.invoiceFormBuilder();
  }

  invoiceFormBuilder() {
    this.invoiceForm = new FormBuilder().group({
      invoiceNumber: [this.invoiceData.invoiceNumber,[Validators.required,Validators.pattern(MESSAGE_CONSTS.ALLOWED_SPECIALCHAR_REGEX)]],
      invoiceDate: [this.invoiceData.invoiceDate, Validators.required],
      serviceDate: [this.invoiceData.serviceDate, Validators.required],
      invoiceAmount: [this.invoiceData.invoiceAmount,[Validators.required,Validators.pattern(MESSAGE_CONSTS.DIGIT_ONLY_REGEX)]],
      typeofService: [this.invoiceData.typeofService,[Validators.required,Validators.pattern(MESSAGE_CONSTS.ALPHA_NUMERIC_REGEX)]]
    });
  }
  
  get invoiceFormControls() {
    return this.invoiceForm.controls;
  }
  /**
   * listing all the invoices
   */
  getinvoiceList() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');
    this.authService
      .getList(
        this._apiUrl +
        "/api/v1/NonCoveredService" + "?pageNumber=" + this.pageNumber + "&pageSize=" + this.pageSize +
        "&searchText=" + this.searchTerm + "&startDatepicker=" + startdate + "&endDatepicker=" + enddate +
        "&UserId=" + this.workshopId
      )
      .subscribe(
        (response) => {
          if (response) {
            this.invoiceList = response.body;
            var pagingProp = JSON.parse(response.headers.get("X-Pagination"));
            this.count = pagingProp.TotalCount;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }
  /**
   * Add,edit invoice modal open and close
   */
  toggleModal(EDIT: boolean, invoiceId) {
    this.EDIT_FLAG = EDIT;
    this.invoiceId = invoiceId;
    this.invoiceModalOpen = !this.invoiceModalOpen;
    this.isSuccess = false;
    if (this.invoiceModalOpen) {
      if (this.EDIT_FLAG) {
        this.getInvoiceDetails(this.invoiceId);
      }
    } else {
      this.invoiceData = new invoiceData();
      this.invoiceFormBuilder();
      this.isSuccess = true;
    }
  }

  confirmModalClose() {
    this.confirmModalOpen = false;
    this.getinvoiceList();
  }

  getInvoiceDetails(invoiceId) {
    this.authService.get(this._apiUrl + "/api/v1/NonCoveredService/" + invoiceId).subscribe(
      (response) => {
        if (response) {
          this.invoiceData = response;
          this.invoiceFormBuilder();
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  addInvoice() {
    this.authService
      .post(this._apiUrl + "/api/v1/NonCoveredService/AddInvoice/" + this.workshopId, this.invoiceForm.value)
      .subscribe(
        (response) => {
          if (response) {
            this.getinvoiceList();
            this.isSuccess = true;
          }
        },
        (error) => {
          console.error(error);
          this.handleError(error);
        }
      );
  }
  /**
   * updating  invoice
   */
  updateInvoice() {
    this.authService
      .put(this._apiUrl + "/api/v1/NonCoveredService/" + this.invoiceId, this.invoiceForm.value)
      .subscribe(
        (response) => {
          this.getinvoiceList();
          this.isSuccess = true;
        },
        (error) => {
          console.error(error);
          this.handleError(error);
        }
      );
  }

  getworkshopList() {
    this.authService
      .get(
        this._apiUrl +
        "/api/v1/Workshops/GetAllWorkshops").subscribe(
          (response) => {
            if (response) {
              this.workshopList = response;
            }
          },
          (error) => {
            console.error(error);
          }
        );
  }

  onDealerChanges(event:any) {
    this.workshopId = event.value;
    this.selectedItem = this.workshopList.find((x: any) => x.workshopId == event.value); 
    this.workshopName= this.selectedItem["workshopName"];
    this.isDealer=true;
    this.getinvoiceList();
  }

  exporttoexcel(){
    this.pageNumber = -1;
    this.getExportData();
  }

  getExportData() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');
    this.authService
      .getList(
        this._apiUrl +
        "/api/v1/NonCoveredService" + "?pageNumber=" + this.pageNumber + "&pageSize=" + this.pageSize +
        "&searchText=" + this.searchTerm + "&startDatepicker=" + startdate + "&endDatepicker=" + enddate +
        "&UserId=" + this.workshopId
      )
      .subscribe(
        (response) => {
          if (response) {
            this.exportdata = [];
            response.body.forEach(element => this.setExportData(element));
            this.bindexcel();
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  setExportData(item: any) {
    var data: any = [];
    data.invoiceNumber = item.invoiceNumber;
    data.invoiceDate = item.invoiceDate;
    data.serviceDate = item.serviceDate;
    data.invoiceAmount = item.invoiceAmount;
    data.typeofService = item.typeofService;
    data.createdDate = item.createdDate;
    data.updatedDate = item.updatedDate;
    this.exportdata.push(data);
  }

  bindexcel() {
    import('xlsx').then(xlsx => {
      /* json data is passed over here */
      const ws: import('xlsx').WorkSheet = xlsx.utils.json_to_sheet(this.exportdata);
      /* generate workbook and add the worksheet */
      const wb: import('xlsx').WorkBook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Service_Payment_Report");
      /* save to file */
      this.fileName =
      "ServicePaymentReport_" + this.workshopName +"_"+
        new Date(Date.now()).toLocaleString().split(",")[0] +
        ".xlsx";
      xlsx.writeFile(wb, this.fileName);
    });
  }


  handleError(error) {
    if (error.error instanceof ErrorEvent) {
      // client-side error
      this.errorMessage = `Error : ${error.error.message}`;
    } else {
      // server-side error
      this.errorMessage = `Error : ${error.error}`;
    }
    this.closed = false;
    this.messageToastService.open(this.errorMessage, {
      context: "info",
      duration: 5000,
    });
    return throwError(this.errorMessage);
  }
}